import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import Bookkeeping from '../../components/bookkeeping';
import BookkeepingIntegration from '../../components/BookkeepingIntegration';
import Loader from '../../components/loader';
import useCompanyId from '../../hooks/useCompanyId';
import { useGetCompany } from '../../stores/FetcherStores/CompanyFetcher';

const BookkeepingView = observer(() => {
  const companyId = useCompanyId();
  const { data: company, isLoading: isCompanyLoading } = useGetCompany(companyId);
  if (isCompanyLoading) {
    return (
      <div className="loaderContainer">
        <div className="loadingInnerContainer">
          <Loader />
        </div>
      </div>
    );
  }
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Bokföring
      </Typography>
      {!company?.bookkeeper ? (
        <>
          <Typography>Detta företag har ingen bokförings koppling</Typography>
          <BookkeepingIntegration />
        </>
      ) : (
        <Bookkeeping />
      )}
    </Box>
  );
});
export default BookkeepingView;
